const systemIndex = [
  {
    title: "Add Product",
    url: "/dashboard/products/add-new-product",
    keywords: ["product create", "product add", "product page"],
  },
  {
    title: "Dashboard",
    url: "/dashboard",
    keywords: ["dashboard", "overview"],
  },
  {
    title: "Orders",
    url: "/dashboard/orders",
    keywords: ["order details", "order page"],
  },
  {
    title: "Return Request",
    url: "/dashboard/orders/return-request",
    keywords: ["return", "return request", "refund"],
  },
  {
    title: "Customers",
    url: "/dashboard/customers",
    keywords: ["customer list", "clients"],
  },
  {
    title: "Products",
    url: "/dashboard/products",
    keywords: ["product list", "catalog"],
  },
  {
    title: "Categories",
    url: "/dashboard/products/categories",
    keywords: ["product categories", "categories"],
  },
  {
    title: "Color",
    url: "/dashboard/products/color",
    keywords: ["product color", "color options"],
  },
  {
    title: "Product Type",
    url: "/dashboard/products/product-type",
    keywords: ["product type", "type list"],
  },
  {
    title: "Collection",
    url: "/dashboard/products/collection",
    keywords: ["product collection", "collections"],
  },
  {
    title: "Analytics",
    url: "/dashboard/analytics",
    keywords: ["analytics", "reports", "data insights"],
  },
  {
    title: "Plugin",
    url: "/dashboard/plugin",
    keywords: ["plugin settings", "plugin management"],
  },
  {
    title: "Promocode",
    url: "/dashboard/promocodes",
    keywords: ["promocode", "discounts", "offers"],
  },
  {
    title: "Promocode Usage",
    url: "/dashboard/promocodes/usage",
    keywords: ["promocode usage", "discount tracking"],
  },
  {
    title: "Users",
    url: "/dashboard/user-management",
    keywords: ["user list", "user management"],
  },
  {
    title: "Settings",
    url: "/dashboard/settings/",
    keywords: ["site settings", "configuration"],
  },
  {
    title: "Get Help",
    url: "/get-help",
    keywords: ["support", "help"],
  },
  {
    title: "Sandbox Store",
    url: "/dashboard/sandbox",
    keywords: ["sandbox", "store testing"],
  },
];

export default systemIndex;
